import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Navigate } from 'react-router-dom';
import Loader from '../../components/Loader';
import { useOnboardingSteps } from '../../hooks/useOnboardingSteps';
/**
 * Impedisce di saltare gli step di onboarding via URL diretto.
 *
 * L'utente può stare solo su uno step già completato (per rivederlo) o sul primo
 * step non ancora completato. Qualsiasi step più avanti — o non applicabile al suo
 * profilo, es. diet-type per i non-B2B — viene reindirizzato al primo step non
 * completato. Attende il caricamento dei dati (Loader) per non reindirizzare su uno
 * stato incompleto (es. al refresh di uno step intermedio).
 */
var OnboardingStepGuard = function (_a) {
    var step = _a.step, children = _a.children;
    var _b = useOnboardingSteps(), steps = _b.steps, firstNotCompletedStep = _b.firstNotCompletedStep, isReady = _b.isReady;
    if (!isReady) {
        return _jsx(Loader, {});
    }
    var requestedIndex = steps.findIndex(function (s) { return s.route === step; });
    var firstNotCompletedIndex = steps.findIndex(function (s) { return s.route === firstNotCompletedStep; });
    // requestedIndex === -1 → step non applicabile all'utente (es. diet-type non-B2B).
    // firstNotCompletedIndex === -1 → onboarding completo (firstNotCompletedStep = Plan):
    //   ogni step applicabile è rivedibile.
    var isAccessible = requestedIndex !== -1 &&
        (firstNotCompletedIndex === -1 || requestedIndex <= firstNotCompletedIndex);
    if (!isAccessible) {
        return _jsx(Navigate, { to: firstNotCompletedStep, replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
export default OnboardingStepGuard;
